import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { faGroupArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import { Observable } from 'rxjs';
import { toggleState } from '../../../../../../shared/misc-utilities/store-utils';
import { fusionStoreToken } from '../../../../../h3ml/state/task-workspace-store';

@Component({
  selector: 'h3-sync-subpoint-shapes-button',
  templateUrl: './sync-subpoint-shapes-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SyncSubpointShapesButtonComponent {
  enabled$: Observable<boolean>;
  tooltip = 'Sync subpoint shapes';

  faGroupArrowsRotate = faGroupArrowsRotate;

  private store = inject(fusionStoreToken);

  constructor() {
    this.enabled$ = this.store('syncSubpointShapes').$;
  }

  toggle() {
    toggleState(this.store('syncSubpointShapes'));
  }
}
